module.exports = __webpack_public_path__ + "static/img/illustration-forgot-password-light.8f960a71.png";